import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import Axios from "../../Axios";

import "./usercourselist.scss";

const noFile = require("../../assets/no-file.png");
const noIMG = require("../../assets/no-image.png");

const stripHtml = (html = "") => {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

const formatLessons = (item) => {
  if (item?.lesson_count !== null && item?.lesson_count !== undefined) {
    return `${item.lesson_count} хичээл`;
  }
  return "0 хичээл";
};

const formatDuration = (item) => {
  if (item?.duration !== null && item?.duration !== undefined) {
    const hours = Math.floor(item.duration / 60);
    const minutes = item.duration % 60;

    if (hours > 0 && minutes > 0) {
      return `${hours} цаг ${minutes} минут`;
    }
    if (hours > 0) {
      return `${hours}цаг`;
    }
    return `${minutes}минут`;
  }

  return "0 минут";
};

const formatStudents = (item) => {
  if (item?.students) return item.students;
  if (item?.enrolled) return item.enrolled;
  return "1.2k+";
};

const getAuthorName = (item) => {
  return (
    item?.teacher ||
    item?.author ||
    item?.user?.name ||
    item?.createdBy ||
    "Баярсайхан Пүрэв-Очир"
  );
};

const UserCourseList = ({ title = "Хичээлүүд", type, inUserCourses = false }) => {
  const { authConfig } = useAuthContext();

  const [data, setData] = useState([]);
  const [sortType, setSortType] = useState("all");

  const getAllCourses = useCallback(() => {
    let typeID = 0;

    if (type === "free") {
      typeID = 1;
    }

    Axios.get(`/courses/${typeID}/list`).then((res) => {
      if (res.status === 200) {
        setData(Array.isArray(res.data) ? res.data : []);
      }
    });
  }, [type]);

  const getUserCourses = useCallback(() => {
    Axios.get("/users_courses/user/paid", authConfig).then((res) => {
      if (res.status === 200) {
        setData(Array.isArray(res.data) ? res.data : []);
      }
    });
  }, [authConfig]);

  useEffect(() => {
    if (inUserCourses) {
      getUserCourses();
    } else {
      getAllCourses();
    }
  }, [inUserCourses, getUserCourses, getAllCourses]);

  const sortedData = useMemo(() => {
    const cloned = [...data];

    switch (sortType) {
      case "name_asc":
        return cloned.sort((a, b) =>
          String(a?.title || "").localeCompare(String(b?.title || "")),
        );
      case "name_desc":
        return cloned.sort((a, b) =>
          String(b?.title || "").localeCompare(String(a?.title || "")),
        );
      default:
        return cloned;
    }
  }, [data, sortType]);

  const badgeText = type === "free" ? "Үнэгүй" : "Төлбөртэй";

  return (
    <section className="userCourses">
        <div className="userCourses__container">
            <div className="userCourses__main">
            <div className="userCourses__board">

                {sortedData.length === 0 ? (
                <div className="userCourses__empty">
                    <div className="userCourses__emptyIcon">📘</div>
                    <h3>Сургалтын мэдээлэл олдсонгүй</h3>
                    <p>Та одоогоор ямар нэг курс аваагүй байна.</p>
                </div>
                ) : (
                <div className="userCourses__grid">
                    {sortedData.map((item) => {
                    const plain = stripHtml(item?.description || "");
                    const short =
                        plain.length > 80 ? `${plain.substring(0, 80)}...` : plain;

                    const author = getAuthorName(item);

                    return (
                        <article key={item.id} className="userCourseCard">
                        <Link
                            to={`/courses/${item.id}`}
                            className="userCourseCard__imageWrap"
                        >
                            <img
                            className="userCourseCard__image"
                            src={item?.cover || noIMG}
                            alt={item?.title}
                            onError={(e) => {
                                e.target.src = noFile;
                            }}
                            />
                            <span className="userCourseCard__badge">Таны курс</span>
                        </Link>

                        <div className="userCourseCard__body">
                            <h3 className="userCourseCard__title">
                            {item?.title}
                            </h3>

                            <p className="userCourseCard__desc">{short}</p>

                            <div className="userCourseCard__author">
                            <div className="userCourseCard__avatar">
                                {author.charAt(0)}
                            </div>

                            <div className="userCourseCard__authorInfo">
                                <strong>{author}</strong>
                                <span>Багш</span>
                            </div>
                            </div>

                            <div className="userCourseCard__meta">
                            <div className="userCourseCard__metaLeft">
                                <span>{formatLessons(item)}</span>
                                <span>{formatDuration(item)}</span>
                            </div>

                            <div className="userCourseCard__metaRight">
                                <strong>{formatStudents(item)}</strong>
                            </div>
                            </div>

                            <div className="userCourseCard__footer">
                            <Link
                                to={`/courses/${item.id}`}
                                className="userCourseCard__button"
                            >
                                Үзэх
                            </Link>
                            </div>
                        </div>
                        </article>
                    );
                    })}
                </div>
                )}

            </div>
            </div>
        </div>
        </section>
  );
};

export default UserCourseList;
